import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { captureReactError, captureRecoverableReactError } from './sentry.js';
import './styles/main.css';

ReactDOM.createRoot(document.getElementById('root')!, {
  onCaughtError: captureReactError,
  onRecoverableError: captureRecoverableReactError,
  onUncaughtError: captureReactError,
}).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
